export const siteSettings = {
  name: "Core Trade Hub",
  link: "https://coretradehub.live",
  email: "support@coretradehub.live",
  appLink: "https://app.coretradehub.live",
};
